<template>
  <div :class="{ 'report-course-page': true, active: active }">
    <PageSkeleton
      :animate="active"
      rotate
    >
      <ReportLeader
        text="无畏向上"
        :active="active"
      />
      <div class="report-text slide-in slide-in-1">
        你参与了<span class="text-bold">{{ reportData.studyCourseCount }}</span>门课程的学习
      </div>
      <div class="report-text slide-in slide-in-2">
        共计<span class="text-bold">{{ reportData.totalStudyHour }}+</span>小时
      </div>
      <div class="report-text slide-in slide-in-3">
        击败了<span class="text-bold">{{ reportData.exceedRatio }}%</span>的同学
      </div>
      <div class="report-text" />
      <div v-if="reportData.totalStudyHour < 5">
        <div class="report-text slide-in slide-in-4">
          不止步不却步
        </div>
        <div class="report-text slide-in slide-in-5">
          起点只是一个记号
        </div>
        <div class="report-text slide-in slide-in-6">
          关键是这一路你是如何奔跑
        </div>
      </div>
      <div v-else-if="reportData.totalStudyHour > 5 && reportData.totalStudyHour <= 10">
        <div class="report-text slide-in slide-in-4">
          行李很轻
        </div>
        <div class="report-text slide-in slide-in-5">
          梦想很重
        </div>
        <div class="report-text slide-in slide-in-6">
          感谢你从未停止求知和分享
        </div>
      </div>
      <div v-else-if="reportData.totalStudyHour > 10 && reportData.totalStudyHour <= 30">
        <div class="report-text slide-in slide-in-4">
          没有横空出世的幸运
        </div>
        <div class="report-text slide-in slide-in-5">
          只有不为人知的努力
        </div>
        <div class="report-text slide-in slide-in-6">
          看似波澜不惊的日复一日
        </div>
        <div class="report-text slide-in slide-in-7">
          每一个刻度都是改变
        </div>
      </div>
      <div v-else-if="reportData.totalStudyHour > 30 && reportData.totalStudyHour <= 80">
        <div class="report-text slide-in slide-in-4">
          让你变好的事情
        </div>
        <div class="report-text slide-in slide-in-5">
          过程都不会是轻松的
        </div>
        <div class="report-text slide-in slide-in-6">
          未来的你一定会感谢现在努力的自己
        </div>
      </div>
      <div v-else-if="reportData.totalStudyHour > 80">
        <div class="report-text slide-in slide-in-4">
          这并不是一串简单的数字
        </div>
        <div class="report-text slide-in slide-in-5">
          而是你热爱专注的厚度
        </div>
        <div class="report-text" />
        <div class="report-text slide-in slide-in-6">
          你的好运藏在实力里
        </div>
        <div class="report-text slide-in slide-in-7">
          也藏在不为人知的努力里
        </div>
      </div>
    </PageSkeleton>
  </div>
</template>
<script setup>
import { inject } from "vue";
import PageSkeleton from "./PageSkeleton.vue";
import ReportLeader from "./ReportLeader.vue";
defineProps({
  active: {
    type: Boolean,
    default: false
  }
});
const reportData = inject("reportData")
</script>
<style lang="scss" scoped>
.report-course-page {
  background: url("~@/assets/student/studyReport/postgraduate/2023/bg-course.png");
  background-size: 100%;
}
</style>